export default "__VITE_ASSET__BQ4ZFL9v__"